import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createNotification } from '../services/notificationService';
import { type CreateNotificationParams } from '../types/notification.types';
import { useAuth } from '@/features/auth/';

export const useNotificationCreate = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (params: Omit<CreateNotificationParams, 'createdByUserId'>) => {
      if (!user?.id) {
        throw new Error('Usuario no autenticado');
      }

      const createParams: CreateNotificationParams = {
        ...params,
        createdByUserId: user.id
      };

      return createNotification(createParams);
    },
    onSuccess: () => {
      // Invalidar la caché de notificaciones para forzar una nueva búsqueda
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    }
  });

  return {
    createNotification: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
    isError: mutation.isError
  };
}; 